import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ModalSize } from '@sharedCR/coreDesignSystem/Modals';

import { openDialogAction } from 'store/global/actions';

import CicEditHistoryList from '../components/CicEditHistoryList';
import { EDIT_HISTORY_TITLE } from '../LoanCicHistory.constants';

/** Read-only edit log of a change whose reason can no longer be edited. */
export const useOpenCicEditHistoryModal = () => {
  const dispatch = useDispatch();

  return useCallback(
    change =>
      dispatch(
        openDialogAction({
          header: `${EDIT_HISTORY_TITLE} · ${change.label}`,
          isRestyled: true,
          size: ModalSize.SMALL,
          body: () => <CicEditHistoryList change={change} />,
        }),
      ),
    [dispatch],
  );
};
